var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-page-header',{attrs:{"content":_vm.titleStr},on:{"back":_vm.clickHeaderBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }